import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CardViewer from "./components/CardViewer";
import OnboardingComponent, {
  OnboardingDataItem,
} from "./components/OnboardingComponent";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/slices/toastSlice";
import { CardProvider } from "./components/CardContext";

const NewCardSuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function getData(): OnboardingDataItem[] {
    return [
      {
        title: t("vcc_created_title"),
        description: [
          t("cardOnboarding_description_newCard_1"),
          t("cardOnboarding_balance", { balance: "00.00", currency: "USD" }),
        ],
        imageSrc: () => (
          <CardProvider>
            <CardViewer key="highnote" provider="highnote" />
          </CardProvider>
        ),
      },
    ];
  }

  const onFinish = () => {
    dispatch(showToast(t("paymentMethod_updated")));
    navigate("/payments");
  };

  return (
    <OnboardingComponent
      data={getData()}
      finishLabel={t("okGotIt")}
      onFinish={onFinish}
    />
  );
};

export default NewCardSuccessPage;
